<template>
  <div class="contact-comp" id="cont-co">
    <div class="filter">
      <ul>
        <li class="sub-menu">
          <p class="filter-name active">
            <span>Выберите тему вопроса</span> <i class="arrow"></i>
          </p>
          <ul>
            <li value="ful" class="active">
              <div class="line"></div>
              <div class="text">Мне нужен Фулфилмент</div>
            </li>
            <li value="call" class="active">
              <div class="text">Мне нужен Колл-центр</div>
            </li>
            <li value="cons" class="active">
              <div class="text">Мне нужен Консалтинг</div>
            </li>
            <li value="invest" class="active">
              <div class="text">Я инвестор</div>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <form id="testform2" autocomplete="off">
      <div>
        <label id="st-lbl">Заполните поля:</label><br />
        <input class="active" type="text" id="name" name="name" v-model="name" placeholder="Как в Вам обращаться?" />
        <div class="contactDiv">
          <input class="active contactDivNum" type="text" id="contactTwo" name="contact"
            placeholder="+998 (12) 345 67 89" v-model="number" />
          <p>Как с Вами связаться?</p>
        </div><br />
        <div class="clock-block">
          <div class="clock"></div>
          <p class="click-press active">Укажите время звонка</p>
          <div class="time-wrap">
            <div class="hour-wrap">
              <div class="hour-up" @click="hourIncrement"></div>
              <div class="hour">{{ hourCounter }}</div>
              <div class="hour-down" @click="hourDecrement"></div>
            </div>
            <div class="btw">:</div>
            <div class="hour-wrap">
              <div class="minute-up" @click="minuteIncrement"></div>
              <div class="minute">{{ minuteCounter }}</div>
              <div class="minute-down" @click="minuteDecrement"></div>
            </div>
          </div>
        </div>
        <br />
        <input class="active" type="text" id="storeName" name="storeName" v-model="why"
          placeholder="Для каких целей вам нужен колл-центр?" /><br /><br />
        <input class="active" type="text" id="storeName" name="storeName" v-model="store"
          placeholder="Название Вашего интернет-магазина?" />
        <input class="active" type="text" id="orders" name="orders" v-model="orderNum"
          placeholder="Какой объём заказов у Вас в день?" /><br /><br />
        <label id="nd-lbl">Вы работаете с:</label><br />
        <div class="checkboxes">
          <label class="container active">
            <input type="checkbox" value="Входящими звонками" class="checkbox" v-model="checkedNames" />
            <span class="checkmark"></span>
            <p>Входящими звонками</p>
          </label>

          <label class="container active">
            <input type="checkbox" value="Исходящими звонками" class="checkbox" v-model="checkedNames" />
            <span class="checkmark"></span>
            <p>Исходящими звонками</p>
          </label>
        </div>
        <textarea class="active" id="w3review" name="w3review" rows="4" cols="50" v-model="addInfo"
          placeholder="Дополнительная информация:">
        </textarea>
        <div class="angle-wrap">
          <a class="enter angle active send" id="send2">Отправить</a>
        </div>
        <p class="agreement">
          Нажимая на кнопку «Отправить», я даю согласие на обработку
          персональных данных»
        </p>
      </div>
    </form>

    <form id="testform" autocomplete="off">
      <div>
        <label id="st-lbl">Заполните поля:</label><br />
        <input class="active" type="text" id="name" name="name" v-model="name" placeholder="Как в Вам обращаться?" />
        <div class="contactDiv">
          <input class="active contactDivNum" type="text" id="contactOne" name="contact"
            placeholder="+998 (12) 345 67 89" v-model="number" />
          <p>Как с Вами связаться?</p>
        </div><br />
        <div class="clock-block">
          <div class="clock"></div>
          <p class="click-press active">Укажите время звонка</p>
          <div class="time-wrap">
            <div class="hour-wrap">
              <div class="hour-up" @click="hourIncrement"></div>
              <div class="hour">{{ hourCounter }}</div>
              <div class="hour-down" @click="hourDecrement"></div>
            </div>
            <div class="btw">:</div>
            <div class="hour-wrap">
              <div class="minute-up" @click="minuteIncrement"></div>
              <div class="minute">{{ minuteCounter }}</div>
              <div class="minute-down" @click="minuteDecrement"></div>
            </div>
          </div>
        </div>
        <br />
        <input class="active" type="text" id="storeName" name="storeName" v-model="store"
          placeholder="Название Вашего интернет-магазина?" />
        <input class="active" type="text" id="orders" name="orders" v-model="orderNum"
          placeholder="Какой объём заказов у Вас в день?" /><br /><br />
        <label id="nd-lbl">Отметьте необходимые услуги:</label><br />
        <div class="checkboxes">
          <label class="container active">
            <input type="checkbox" value="Хранение товара" class="checkbox" v-model="checkedNames" />
            <span class="checkmark"></span>
            <p>Хранение товара</p>
          </label>

          <label class="container active">
            <input type="checkbox" value="Колл-центр" class="checkbox" v-model="checkedNames" />
            <span class="checkmark"></span>
            <p>Колл-центр</p>
          </label>

          <label class="container active">
            <input type="checkbox" value="Работа наложенным платёжом" class="checkbox" v-model="checkedNames" />
            <span class="checkmark"></span>
            <p>Работа наложенным платёжом</p>
          </label>

          <label class="container active">
            <input type="checkbox" value="Доставка заказов" class="checkbox" v-model="checkedNames" />
            <span class="checkmark"></span>
            <p>Доставка заказов</p>
          </label>
          <label class="container active">
            <input type="checkbox" value="Обработка возвратов" class="checkbox" v-model="checkedNames" />
            <span class="checkmark"></span>
            <p>Обработка возвратов</p>
          </label>
        </div>
        <textarea class="active" id="w3review" name="w3review" rows="4" cols="50" v-model="addInfo"
          placeholder="Дополнительная информация:">
        </textarea>
        <div class="angle-wrap">
          <a class="enter angle active send" id="send">Отправить</a>
        </div>
        <p class="agreement">
          Нажимая на кнопку «Отправить», я даю согласие на обработку
          персональных данных»
        </p>
      </div>
    </form>

    <form id="testform3" autocomplete="off">
      <div>
        <label id="st-lbl">Заполните поля:</label><br />
        <input class="active" type="text" id="name" name="name" v-model="name" placeholder="Как в Вам обращаться?" />
        <div class="contactDiv">
          <input class="active contactDivNum" type="text" id="contactThree" name="contact" v-model="number"
            placeholder="+998 (12) 345 67 89" />
          <p>Как с Вами связаться?</p>
        </div><br />
        <div class="clock-block">
          <div class="clock"></div>
          <p class="click-press active">Укажите время звонка</p>
          <div class="time-wrap">
            <div class="hour-wrap">
              <div class="hour-up" @click="hourIncrement"></div>
              <div class="hour">{{ hourCounter }}</div>
              <div class="hour-down" @click="hourDecrement"></div>
            </div>
            <div class="btw">:</div>
            <div class="hour-wrap">
              <div class="minute-up" @click="minuteIncrement"></div>
              <div class="minute">{{ minuteCounter }}</div>
              <div class="minute-down" @click="minuteDecrement"></div>
            </div>
          </div>
        </div>
        <br />
        <textarea class="active" id="whatYouDo" name="w3review" rows="4" cols="50" v-model="whatYouDo"
          placeholder="Опишите максимально подробно чем вы занимаетесь?">
        </textarea><br /><br />
        <label id="nd-lbl">Чем мы можем вам помочь?</label><br />
        <div class="checkboxes">
          <label class="container active">
            <input type="checkbox" value="Внедрение CRM-системы" class="checkbox" v-model="checkedNames" />
            <span class="checkmark"></span>
            <p>Внедрение CRM-системы</p>
          </label>

          <label class="container active">
            <input type="checkbox" value="Управление call-центром" class="checkbox" v-model="checkedNames" />
            <span class="checkmark"></span>
            <p>Управление call-центром</p>
          </label>

          <label class="container active">
            <input type="checkbox" value="Посторенние финансовой отчётности и аналитики" class="checkbox"
              v-model="checkedNames" />
            <span class="checkmark"></span>
            <p>Посторенние финансовой отчётности и аналитики</p>
          </label>

          <label class="container active">
            <input type="checkbox" value="Управление складом" class="checkbox" v-model="checkedNames" />
            <span class="checkmark"></span>
            <p>Управление складом</p>
          </label>

          <label class="container active">
            <input type="checkbox" value="Управление рекламой" class="checkbox" v-model="checkedNames" />
            <span class="checkmark"></span>
            <p>Управление рекламой</p>
          </label>
        </div>
        <br /><br />
        <label id="nd-lbl">Другое:</label><br />
        <textarea class="active" id="w3review" name="w3review" rows="4" v-model="also" cols="50">
        </textarea>
        <div class="angle-wrap">
          <a class="enter angle active send" id="send3">Отправить</a>
        </div>
        <p class="agreement">
          Нажимая на кнопку «Отправить», я даю согласие на обработку
          персональных данных»
        </p>
      </div>
    </form>

    <form id="testform4" autocomplete="off">
      <div>
        <label id="st-lbl">Заполните поля:</label><br />
        <input class="active" type="text" id="name" name="name" v-model="name" placeholder="Как в Вам обращаться?" />
        <div class="contactDiv">
          <input class="active contactDivNum" type="text" id="contactFour" name="contact" v-model="number"
            placeholder="+998 (12) 345 67 89" />
          <p>Как с Вами связаться?</p>
        </div><br />
        <div class="clock-block">
          <div class="clock"></div>
          <p class="click-press active">Укажите время звонка</p>
          <div class="time-wrap">
            <div class="hour-wrap">
              <div class="hour-up" @click="hourIncrement"></div>
              <div class="hour">{{ hourCounter }}</div>
              <div class="hour-down" @click="hourDecrement"></div>
            </div>
            <div class="btw">:</div>
            <div class="hour-wrap">
              <div class="minute-up" @click="minuteIncrement"></div>
              <div class="minute">{{ minuteCounter }}</div>
              <div class="minute-down" @click="minuteDecrement"></div>
            </div>
          </div>
        </div>
        <br />
        <input class="active" type="text" id="storeName" name="storeName" v-model="sphere"
          placeholder="В какой сфере вы хотите запустить проект?" />
        <input class="active" type="text" id="orders" name="orders" v-model="money"
          placeholder="Сумма ваших инвестиций?" /><br /><br />

        <textarea class="active" id="w3review" name="w3review" rows="4" cols="50" v-model="experience"
          placeholder="Ваш опыт в электронной коммерции?">
        </textarea>
        <input class="active" type="text" id="orders2" name="orders" v-model="resources"
          placeholder="Ваши ресурсы и связи?" />
        <div class="angle-wrap">
          <a class="enter angle active send" id="send4">Отправить</a>
        </div>
        <p class="agreement">
          Нажимая на кнопку «Отправить», я даю согласие на обработку
          персональных данных»
        </p>
      </div>
    </form>
    <div class="submitted">Ваша форма была отправлена</div>
    <div class="forgot">Заполните все поля</div>
    <div class="nothing" v-if="isHome"></div>
    <div class="nothing" v-else-if="isHomeTwo"></div>
  </div>
</template>

<script>
import axios from "axios"
import $ from "jquery";
import { AsYouType } from 'libphonenumber-js/max/index'
var countries = require("i18n-iso-countries");
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
countries.registerLocale(require("i18n-iso-countries/langs/ru.json"));

export default {
  name: "contact-comp",
  computed: {
    isHome() {
      return this.$route.path === '/contact'
    },
    isHomeTwo() {
      return this.$route.path === '/contactmobile'
    },
  },
  data() {
    return {
      musicButton: false,
      hourCounter: "в любое",
      minuteCounter: "время",
      number: null,
      store: null,
      orderNum: null,
      addInfo: null,
      name: null,
      subject: null,
      checkedNames: [],
      why: null,
      whatYouDo: null,
      also: null,
      sphere: null,
      money: null,
      experience: null,
      resources: null,
    };
  },
  methods: {
    hourIncrement() {
      if (this.hourCounter == 23) {
        this.hourCounter = 0;
      } else {
        this.hourCounter++;
      }
    },
    hourDecrement() {
      if (this.hourCounter == 0) {
        this.hourCounter = 23;
      } else {
        this.hourCounter--;
      }
    },
    minuteDecrement() {
      if (this.minuteCounter == 0) {
        this.minuteCounter = 59;
      } else {
        this.minuteCounter--;
      }
    },
    minuteIncrement() {
      if (this.minuteCounter == 59) {
        this.minuteCounter = 0;
      } else {
        this.minuteCounter++;
      }
    },
    sendMessage() {
      const params = new URLSearchParams();
      params.append('name', this.name);
      params.append('subject', this.subject);
      params.append('number', this.number);
      params.append('store', this.store);
      params.append('orderNum', this.orderNum);
      params.append('addInfo', this.addInfo);
      params.append('checkedNames', this.checkedNames);
      params.append('why', this.why);
      params.append('whatYouDo', this.whatYouDo);
      params.append('also', this.also);
      params.append('sphere', this.sphere);
      params.append('money', this.money);
      params.append('experience', this.experience);
      params.append('resources', this.resources);
      axios.post("/mail.php", params)
        .then((response) => {
          console.log("Ответ: " + response);
        });
    },

    addToDatabase() {
      const messagesRef = this.$firebaseDatabase.collection("emails");
      messagesRef.add({
        name: this.name,
        time: this.hourCounter + " : " + this.minuteCounter,
        subject: this.subject,
        number: this.number,
        store: this.store,
        orderNum: this.orderNum,
        addInfo: this.addInfo,
        checkedNames: this.checkedNames,
        why: this.why,
        whatYouDo: this.whatYouDo,
        also: this.also,
        sphere: this.sphere,
        money: this.money,
        experience: this.experience,
        resources: this.resources,
      });
    },
  },
  mounted() {
    var load = this;

    var name;

    function send() {
      $(".forgot").fadeOut();
      $(".submitted").fadeIn();
      name = $('.filter-name span').text();
      load.subject = name;
      load.sendMessage();
      //load.addToDatabase();
    }

    $(".send").click(function () {
      name = $(".filter-name span").text();
      if (name == "Мне нужен Фулфилмент") {
        if (
          !load.name ||
          !load.number ||
          !load.store ||
          !load.orderNum ||
          load.checkedNames.length == 0
        ) {
          $(".forgot").fadeIn();
        } else {
          send();
        }
      } else if (name == "Мне нужен Колл-центр") {
        if (
          !load.name ||
          !load.number ||
          !load.store ||
          !load.orderNum ||
          !load.why ||
          load.checkedNames.length == 0
        ) {
          $(".forgot").fadeIn();
        } else {
          send();
        }
      } else if (name == "Мне нужен Консалтинг") {
        if (
          !load.name ||
          !load.number ||
          !load.whatYouDo ||
          load.checkedNames.length == 0
        ) {
          $(".forgot").fadeIn();
        } else {
          send();
        }
      } else if (name == "Я инвестор") {
        if (
          !load.name ||
          !load.number ||
          !load.sphere ||
          !load.money ||
          !load.experience ||
          !load.resources
        ) {
          $(".forgot").fadeIn();
        } else {
          send();
        }
      }
    });

    function showMusic() {
      $(".click-press").show();
      $(".time-wrap").css("display", "none");
      load.musicButton = false;

      load.hourCounter = "в любое"
      load.minuteCounter = "время"
    }

    function hideMusic() {
      $(".click-press").hide();
      $(".time-wrap").css("display", "inline-block");
      load.musicButton = true;

      load.hourCounter = 12
      load.minuteCounter = 30
    }

    $(".click-press").click(function () {
      hideMusic();
    });

    $(".clock").click(function () {
      if (load.musicButton) {
        showMusic();
      } else {
        hideMusic();
      }
    });


    $(".sub-menu ul").hide();
    $(".sub-menu .filter-name").click(function () {
      $(".sub-menu ul li").click(function () {
        $(this)
          .parent()
          .parent()
          .find("span")
          .text(
            $(this)
              .children(".text")
              .text()
          );
        $(".sub-menu")
          .children("ul")
          .slideUp();
        $(".filter-name .arrow").css("transform", "rotate(0deg)");
        name = $(this)
          .children(".text")
          .text();
        stateChange(name);

        load.subject = name;
        load.checkedNames = [];
        load.store = null;
        load.orderNum = null;
        load.addInfo = null;
        load.addInfo = null;
        load.whatYouDo = null;
        load.also = null;
        load.sphere = null;
        load.money = null;
        load.experience = null;
        load.resources = null;
      });

      if (
        $(this)
          .parent(".sub-menu")
          .children("ul")
          .is(":visible")
      ) {
        $(this)
          .parent(".sub-menu")
          .children("ul")
          .slideUp();

        $(this)
          .parent(".sub-menu")
          .children(".filter-name")
          .css("color", "#8b8b8b");

        $(this)
          .find(".arrow")
          .css("transform", "rotate(0deg)");
      } else {
        $(".sub-menu ul").slideUp();

        $(".filter-name .arrow").css("transform", "rotate(180deg)");

        $(this)
          .parent(".sub-menu")
          .children("ul")
          .slideToggle("100");
        $(this)
          .parent(".sub-menu")
          .children(".filter-name")
          .css("color", "black");

        $(this)
          .find(".arrow")
          .css("transform", "rotate(180deg)");
      }
    });

    // $(".contactDiv .contactNumber").html("<span> +7 </span>");

    function number(name) {
      $(name).on("change keyup paste click", function (e) {
        // this.value = this.value.replace(/[^0-9 +]+$/g, '');

        var oof = new AsYouType()
        oof.input(this.value)
        // oof.formattedOutput = '+' + this.value
        this.value = oof.formattedOutput

        // this.value = 

        // console.log(oof)

        // console.log(countries.getName(oof.country, "ru"));
      })
    }

    number("#contactOne")
    number("#contactTwo")
    number("#contactThree")
    number("#contactFour")

    $(document).ready(function () {
      stateChange(name);
    });

    function stateChange(stateValue) {
      $("form").hide();
      $(".nothing").hide();

      switch (stateValue) {
        case "Мне нужен Фулфилмент":
          $("#testform").show();
          break;
        case "Мне нужен Колл-центр":
          $("#testform2").show();
          break;
        case "Мне нужен Консалтинг":
          $("#testform3").show();
          break;
        case "Я инвестор":
          $("#testform4").show();
          break;
        default:
          $(".nothing").show();
      }
    }
  },
};
</script>

<style scoped>
.contactNumber {
  z-index: 14 !important;
  left: 3vw;
  pointer-events: none;
  display: block;
  background-color: none;
  font-size: 1em !important;
  /* width: 40%; */
}

#contactOne::placeholder,
#contactTwo::placeholder,
#contactThree::placeholder,
#contactFour::placeholder {
  opacity: 0.5;
}

.submitted,
.forgot {
  text-align: center;
  margin-top: 40px;
  color: #2778f3;
  text-shadow: #2778f3 0 0 50px;
  display: none;
  margin-bottom: 30px;
}

.forgot {
  color: #dc2035;
  text-shadow: #dc2035 0 0 50px;
}

#orders2 {
  margin-left: 2vw;
  margin-top: 30px;
  vertical-align: top;
}

#contact::placeholder {
  text-align: right;
  padding: 10px;
}

.hour-wrap {
  display: inline-block;
}

.btw {
  position: absolute;
  top: 47.5%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.hour-up,
.hour-down,
.hour,
.minute-up,
.minute-down,
.minute {
  width: calc(50px / 3);
  height: calc(50px / 3);
  text-align: center;
  margin-left: 10px;
}

.minute-up,
.minute-down,
.minute {
  margin-left: 20px;
}

.hour-up,
.hour-down,
.minute-up,
.minute-down {
  background-image: url("../assets/arrow2.svg");
  background-repeat: no-repeat;
  background-position: center;
}

.hour,
.minute {
  line-height: 15px;
}

.hour-up,
.minute-up {
  background-position: center;
  transform: rotate(180deg);
}

.hour-down,
.minute-down {
  background-position: 60% 35%;
}

.time-wrap {
  display: none;
  position: relative;
  height: 50px;
  width: 75px;
  background-color: #545454;
  border: 1px solid #a4a4a4;
  vertical-align: middle;
  margin-top: -25px;
  margin-left: 20px;
}

.angle-wrap {
  display: flex;
  position: relative;
  margin-bottom: 20px;
}

.angle {
  margin-top: 20px;
  font-size: 0.8em;
  padding: 10px;
}

.angle::before {
  background-color: #2778f3;
  width: 85%;
}

.agreement {
  color: #a1a1a1;
  font-family: Montserrat-Light;
  width: 35%;
  font-size: 0.9em;
}

.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.container {
  position: relative;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #575757;
  border: 1px solid #a4a4a4;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.container input:checked~.checkmark:after {
  display: block;
}

.container .checkmark:after {
  left: 4.5px;
  top: 4px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: white;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.checkboxes {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-row-gap: 20px;
  grid-column: 20px;
  margin-top: 20px;
}

.container p {
  display: inline-block;
  margin-left: 25px;
  font-size: 0.7em;
  user-select: none;
  -moz-user-select: none;
}

.checkbox {
  width: unset;
  height: unset;
}

.click-press {
  display: inline-block;
  vertical-align: middle;
  margin-top: -20px;
  margin-left: 10px;
  font-size: 0.7em;
}

.clock {
  width: 30px;
  height: 100%;
  background-image: url("../assets/clock.png");
  background-size: cover;
  display: inline-block;
}

.clock-block {
  height: 30px;
  margin-left: 40vw;
  margin-top: 20px;
}

input {
  width: 38vw;
  height: 40px;
  border: #a4a4a4 1px solid;
  background-color: #575757;
  padding-left: 10px;
  outline: none;
  color: white;
}

input::placeholder {
  font-family: Montserrat-LightI;
  color: white;
}

textarea::placeholder {
  font-family: Montserrat;
  color: white;
}

textarea {
  margin-top: 30px;
  background-color: #545454;
  border: 1px solid #a4a4a4;
  padding: 10px;
  width: 38vw;
  max-width: 38vw;
  height: 20vw;
  max-height: 30vw;
  outline: none;
}

input:-internal-autofill-selected {
  background-color: #575757 !important;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0), inset 0 0 0 100px #575757;
  color: white !important;
}

form {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
}

#contactOne,
#contactTwo,
#contactThree,
#contactFour {
  /* margin-top: 15px; */
  margin-left: 2vw;
}

.contactDiv {
  display: inline-block;
  position: relative;
  height: 40px;
  margin-top: 15px;
  z-index: 0;
}

.contactDiv p {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-family: Montserrat-LightI;
  font-size: 0.7em;
  color: rgba(255, 255, 255, 0.5);
  background-color: #575757;
  z-index: 15;
}

#orders {
  margin-left: 2vw;
}

.line {
  width: 80%;
  height: 2px;
  background-color: #a4a4a4;
  margin: 0 auto;
  transform: translateY(-25px);
}

.filter {
  position: relative;
  z-index: 1;
  background-color: #575757;
  width: 38vw;
  padding: 13px 20px;
  margin-left: 10px;
  border: 1px solid #a4a4a4;
}

.filter li {
  list-style: none;
}

.sub-menu {
  display: inline-block;
}

.sub-menu ul {
  background-color: #575757;
  position: absolute;
  width: 100.5%;
  left: -1px;
  top: 45px;
  border: 1px solid #a4a4a4;
  border-top: none;
  z-index: 40;
}

.sub-menu ul li:nth-child(1) {
  padding-top: 30px;
}

.sub-menu ul li {
  color: #fff;
  padding: 15px 20px;
  transition: 0.3s;
  cursor: pointer;
  position: relative;
}

.sub-menu ul li:hover {
  opacity: 0.3;
}

.filter-name {
  transition: 0.3s;
  width: 35vw;
}

.filter-name .arrow {
  background-image: url("../assets/arrow2.svg");
  background-repeat: no-repeat;
  background-position: center;
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: middle;
  float: right;
  transition: 0.3s;
}

form {
  margin-left: 10px;
  margin-bottom: 50px;
}

.contact-comp {
  width: 80vw;
  margin: 0 auto;
}

.nothing {
  height: 70vh;
}

@media only screen and (max-width: 900px) {
  .filter {
    width: 100%;
    margin-left: 0;
  }

  .contact-comp {
    width: 100vw;
  }

  .filter-name {
    width: 90vw;
  }

  form {
    margin-left: 0;
  }

  input {
    width: 100vw;
  }

  #contactOne,
  #contactTwo,
  #contactThree,
  #contactFour {
    margin-left: 0;
  }

  #orders {
    margin-left: 0;
    margin-top: 15px;
  }

  #orders2 {
    margin-left: 0;
  }

  #storeName {
    margin-top: 15px;
  }

  #contact {
    margin-bottom: 15px;
  }

  .clock-block {
    margin-left: 0;
  }

  .checkboxes {
    grid-template-columns: 1fr;
  }

  .checkmark {
    width: 30px;
    height: 30px;
  }

  .container p {
    margin-left: 40px;
    font-size: 13px;
    margin-top: 7px;
  }

  .container .checkmark:after {
    width: 19px;
    height: 19px;
  }

  textarea {
    width: 100vw;
    max-width: 100vw;
    height: 40vh;
    max-height: 100vh;
  }

  #send,
  #send2,
  #send3,
  #send4 {
    width: 50%;
    background-color: #2778f3;
  }

  .agreement {
    width: 100%;
  }

  #name {
    margin-top: 40px;
  }
}
</style>
